"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.base64toBlob = base64toBlob;
exports.readNative = readNative;
exports.base64ToBuffer = base64ToBuffer;
exports.isFileApiSupported = isFileApiSupported;
var promise_1 = require("../utils/promise");
var string_1 = require("../utils/string");
var win_1 = require("../win");
function base64toBlob(base64Data, contentType) {
    contentType = contentType || "";
    if (Uint8Array["fromBase64"]) {
        return new Blob([Uint8Array["fromBase64"](base64Data)], {
            type: contentType,
        });
    }
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);
    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        var begin = sliceIndex * sliceSize;
        var end = Math.min(begin + sliceSize, bytesLength);
        var bytes = new Array(end - begin);
        for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
}
function readNative(readFunc) {
    var reader = new FileReader();
    return (0, promise_1.newPromise)(function (resolve, reject) {
        reader.onload = function (e) {
            resolve(reader.result);
        };
        reader.onerror = function () {
            reject(new Error("failed readAsText"));
        };
        readFunc(reader);
    });
}
var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function base64ToBuffer(base64, buffer) {
    //get last chars to see if are valid
    var input = base64;
    input = (0, string_1.removePaddingChars)(input);
    input = (0, string_1.removePaddingChars)(input);
    var bytes = parseInt(((input.length / 4) * 3).toString(), 10);
    var uarray;
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var j = 0;
    if (buffer)
        uarray = new Uint8Array(buffer);
    else
        uarray = new Uint8Array(bytes);
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    for (var i = 0; i < bytes; i += 3) {
        //get the 3 octects in 4 ascii chars
        enc1 = _keyStr.indexOf(input.charAt(j++));
        enc2 = _keyStr.indexOf(input.charAt(j++));
        enc3 = _keyStr.indexOf(input.charAt(j++));
        enc4 = _keyStr.indexOf(input.charAt(j++));
        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;
        uarray[i] = chr1;
        if (enc3 != 64)
            uarray[i + 1] = chr2;
        if (enc4 != 64)
            uarray[i + 2] = chr3;
    }
    return uarray;
}
function isFileApiSupported() {
    var w = (0, win_1.win)();
    var isSupported = w.FileReader && w.File && w.FileList && w.Blob;
    return isSupported;
}
